/**
 * E2E builds only: `window.__precip` is what the tests read about the precipitation overlay. The
 * forecast layer and the radar layer each register while they are mounted ("forecast" or "radar"
 * as `mode`); a layer that leaves never removes the hook of the one that replaced it.
 */
type Getter = () => Record<string, unknown>;
let owner: object | null = null;

export function registerPrecipHook(by: object, get: Getter): () => void {
  if (import.meta.env.VITE_E2E !== "1") return () => {};
  owner = by;
  Object.defineProperty(window, "__precip", { configurable: true, get });
  return () => {
    if (owner !== by) return;
    owner = null;
    delete (window as { __precip?: unknown }).__precip;
  };
}
